import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { useCellSelectionDispatch, useCellSelectionSelector } from '../../redux/reduxHooks';
import { endDrag, getIsDragging, getDragMethod, getDidDragMove } from '../redux/cellSelectionSlice';
import { useTrackCellSelection } from '../context/CellSelectionContext';

/**
 * Ends an in-progress drag on the next mouseup anywhere in the document. A
 * document-level listener (rather than one on the table) is required so that
 * releasing the mouse outside the table still finishes the selection.
 */
export const useEndDragOnMouseUp = () => {
  const $ = _c(7);
  const dispatch = useCellSelectionDispatch();
  const track = useTrackCellSelection();
  const isDragging = useCellSelectionSelector(getIsDragging);
  const dragMethod = useCellSelectionSelector(getDragMethod);
  const didDragMove = useCellSelectionSelector(getDidDragMove);
  let t0;
  let t1;
  if ($[0] !== didDragMove || $[1] !== dispatch || $[2] !== dragMethod || $[3] !== isDragging || $[4] !== track) {
    t0 = () => {
      if (!isDragging) {
        return;
      }
      const handleMouseUp = () => {
        if (dragMethod && didDragMove) {
          track === null || track === void 0 || track({
            type: "cellSelectionChanged",
            method: dragMethod
          });
        }
        dispatch(endDrag());
      };
      document.addEventListener("mouseup", handleMouseUp);
      return () => document.removeEventListener("mouseup", handleMouseUp);
    };
    t1 = [didDragMove, dispatch, dragMethod, isDragging, track];
    $[0] = didDragMove;
    $[1] = dispatch;
    $[2] = dragMethod;
    $[3] = isDragging;
    $[4] = track;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
};